export class Variable {
  name: string;
  value: string;
  scope: string;
  status = 'unchanged';

  public constructor(name: string, value: string, scope: string) {
    this.name = name;
    this.value = value;
    this.scope = scope;
  }
}